;(function() {
  'use strict'

  controller.$inject = ["$scope"];
  angular.module('core.cardSurvey').controller('CardSurvey', controller)

  /* @ngInject */
  function controller($scope) {
    $scope.backgroundStyle = backgroundStyle

    function backgroundStyle(url) {
      return {
        'background-image': 'url(' + url + ')',
      }
    }
  }
})()
